import Alpine from 'alpinejs'
import sal from 'sal.js'
import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import './main.css'

// https://fontsource.org/fonts/archivo/install
import '@fontsource/archivo/300.css'; // Light
import '@fontsource/archivo/400.css'; // Normal
import '@fontsource/archivo/600.css'; // Semibold


// ---------------------------------------------------------------------------------------------------- HOT MODULE REPLACEMENT
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

// ---------------------------------------------------------------------------------------------------- SAL.JS (SCROLL TRANSITIONS)
sal({
  threshold: 0.01,

});

// ---------------------------------------------------------------------------------------------------- SWIPER
window.Swiper = Swiper
Swiper.use([Navigation, Pagination, Autoplay]);

function setSlideHeight(el) {
  // Reset all slide heights to 'auto'
  el.slides.forEach(slide => {
    slide.style.height = 'auto';
  });

  if (window.innerWidth < 1208) return;

  // Get the current slide's height
  const currentSlide = el.activeIndex;
  const newHeight = el.slides[currentSlide].offsetHeight;

  // Set the height for swiper-wrapper and all slides
  const wrapper = el.wrapperEl;
  if (wrapper) wrapper.style.height = newHeight + 'px';
  el.slides.forEach(slide => {
    slide.style.height = newHeight + 'px';
  });

  el.update();
}
document.querySelectorAll('.feature-slider').forEach((sliderEl) => {
  const nextEl = sliderEl.parentElement.querySelector('.swiper-button-next');
  const prevEl = sliderEl.parentElement.querySelector('.swiper-button-prev');
  const paginationEl = sliderEl.parentElement.querySelector('.swiper-pagination');

  new Swiper(sliderEl, {
    autoplay: { 
      delay: 3500,
      pauseOnMouseEnter: true,
      stopOnLastSlide: true
    },
    speed: 500,
    loop: false,
    navigation: {
      nextEl,
      prevEl
    },
    pagination: {
      el: paginationEl,
      clickable: true
    },
    on: {
      init: function () {
        setSlideHeight(this);
      },
      resize: function () {
        setSlideHeight(this);
      },
      slideChangeTransitionEnd: function () {
        setSlideHeight(this);
      }
    },
    breakpoints: {
      1208: {
        direction: 'vertical',
      }
    }
  });
});

// ---------------------------------------------------------------------------------------------------- ALPINE
window.Alpine = Alpine
Alpine.start();
